import React, { useRef, useEffect } from "react";
import QRCode from 'react-qr-code';
import styles from "./index.module.css";
import Logo from "../../../assets/images/brand/IBS portrait.png";
import Stamp from "../../../assets/images/brand/star-stamp.png";
import Seal from "../../../assets/images/brand/Seal-removebg-preview.png";

const QR_Link = process.env.REACT_APP_PUBLIC_QR_LINK;

const IBSShadowCertificateImage = () => {
    return (
        // <div className={`main-card`}>
        <div className={styles.certificateContainer}>
            <img src={Logo} alt="Logo" className={styles.logo} />
            <p className={styles.text}>This is to certify that</p>
            <p className={styles.studentName}>xxxxxxxxxxxxxxx</p>
            <p className={styles.textSentence}>
                having fulfilled the conditions prescribed by the
            </p>
            <p className={styles.textSentence}>
                University is this day admitted to
            </p>
            <h3 className={styles.courseName}>xxxxxxxxxxxxxxxxxx</h3>
            <p className={styles.textSentence}>Given under the common seal of IBSUniversity</p>
            <p className={styles.textSentence}>dd/mm/yyyy</p>
            <div className={styles.footer}>
                <div className={styles.sealContainer}>
                    <img src={Seal} alt="Seal" className={styles.sealImg} />
                    <p className={styles.signature}>XXXXXXXXXX</p>
                    <p className={styles.signatureBottom}>XXXXXXXXXX</p>
                </div>
                <img src={Stamp} alt="Stamp" className={styles.stamp} />
                <div style={{ textAlign: "center" }}>
                    <QRCode
                        value={`${QR_Link}`}
                        size={70}
                        className={styles.qrCode}
                        color="#f1f1f1"
                        fgColor="#f1f1f1"
                    />
                    <p className={styles.qrText}>Scan to verify certificate.</p>
                    <p className={styles.detailsText}>Document Ref.: xxxxxxxxxxx</p>
                    <p className={styles.detailsText}>Completion Date: dd/mm/yyyy</p>
                </div>
            </div>
        </div>
        // </div>
    );
};

export default IBSShadowCertificateImage;